import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './styles.module.scss';

function StickyContainer({ children, bg }) {
  const [sticky, setSticky] = useState(false);
  const [height, setHeight] = useState('auto');
  const containerRef = useRef(null);

  useEffect(() => {
    setHeight(`${containerRef.current?.offsetHeight}px`);
  }, [containerRef]);

  const updateStickyStatus = useCallback(
    // web can just be 0 instead of computedStyle
    () => {
      const { top } = containerRef.current.getBoundingClientRect();
      if (
        top <
        parseInt(getComputedStyle(document.documentElement).getPropertyValue('--safe-area-inset-top'), 10)
      )
        setSticky(true);
      else setSticky(false);
    },
    [containerRef]
  );

  useEffect(() => {
    if (window.PLATFORM === 'web') {
      updateStickyStatus();
      window.addEventListener('scroll', updateStickyStatus, { passive: true });
      return () => window.removeEventListener('scroll', updateStickyStatus);
    }
    return () => {};
  }, [updateStickyStatus]);

  return (
    <div
      ref={containerRef}
      style={{
        height: sticky ? height : 'auto'
      }}>
      <div className={classnames([{ [styles.sticky]: sticky, [styles.bg]: bg }])}>{children}</div>
    </div>
  );
}

StickyContainer.propTypes = {
  children: PropTypes.any, // eslint-disable-line
  bg: PropTypes.bool
};

StickyContainer.defaultProps = {
  bg: false
};

export default StickyContainer;
